import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "motion/react";
import { transitionSoft, viewportOnce } from "../animations";

const cardBase =
  "bgBorderStile rombStyle relative flex items-center justify-center overflow-hidden rounded-[14px] border border-black/5 bg-gradient-to-br from-white via-[#fff4f4] to-[#eeeeee] shadow-[0_18px_45px_-28px_rgba(0,0,0,0.35)] transition-shadow duration-300 hover:shadow-[0_26px_65px_-32px_rgba(0,0,0,0.45)]";

function Functionality() {
  const { t } = useTranslation();
  const delays = [0.08, 0.14, 0.2, 0.26];
  return (
    <section
      id="functionality"
      className="m-auto mt-[50px] px-4 md:mt-[60px] lg:mt-[80px] lg:max-w-[1024px] xl:mt-[144px] xl:max-w-[1280px]"
    >
      <motion.h4
        className="text-[20px] font-medium uppercase text-[#da0011] md:text-[26px] lg:text-[30px] xl:text-[36px]"
        initial={{ opacity: 0, y: 22 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={viewportOnce}
        transition={transitionSoft}
      >
        {t("functionality.heading")}
      </motion.h4>
      <div className="mt-[70px] flex flex-wrap justify-between md:flex-wrap">
        {[
          {
            p: "p-[40px]",
            extra: "",
            icon: "./img/seyf.svg",
            titleKey: "accounts",
          },
          {
            p: "p-[45px]",
            extra: "",
            icon: "./img/calendar.svg",
            titleKey: "stats",
          },
          {
            p: "p-[40px]",
            extra: "mt-[20px] md:mt-[0]",
            icon: "./img/moneti.svg",
            titleKey: "bills",
          },
          {
            p: "p-[50px]",
            extra: "mt-[20px] md:mt-[16px] lg:mt-0 xl:mt-[0]",
            icon: "./img/zomok.svg",
            titleKey: "swift",
          },
        ].map((item, i) => (
          <motion.div
            key={item.icon}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={viewportOnce}
            transition={{ ...transitionSoft, delay: delays[i] }}
            whileHover={{ y: -6, scale: 1.03 }}
            whileTap={{ scale: 0.99 }}
            className={`${cardBase} ${item.p} ${item.extra}`}
          >
            <div
              className="pointer-events-none absolute inset-0 opacity-60"
              style={{
                background:
                  "radial-gradient(260px 180px at 30% 25%, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0) 60%), radial-gradient(300px 220px at 85% 85%, rgba(218,0,17,0.08) 0%, rgba(218,0,17,0) 65%)",
              }}
              aria-hidden
            />
            <img alt="" className="rombStyle absolute" src="./img/romb.svg" />
            <div className="relative items-end">
              <img alt="" src={item.icon} />
              <h4 className="whitespace-pre-line text-center text-[18px] font-bold leading-snug text-[#111827]">
                {t(`functionality.cards.${item.titleKey}.title`)}
              </h4>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
export default Functionality;
